<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="m-2">
      <b-row>
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <!-- Per Page -->
          <list-per-page
            :total="total"
            :current-per-page="perPage"
            @onChangePerPage="changePerPage"
          />
          <b-button
            v-if="$can('create','products')"
            variant="success"
            @click="createButtonClicked"
          >
            {{ $t('Create product') }}
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-col>
        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <list-search @onSearch="search" />
          </div>
        </b-col>
      </b-row>
    </div>
    <table-loader v-if="loader" />
    <products-list
      v-else
      :fields="fields"
      :items="items"
      :additional-data="additionalData"
      @onDeleteButtonClicked="deleteButtonClicked"
    />

    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </b-card>
</template>

<script>
import { ListIndex } from '../../../common/mixins/list'
import ProductsList from '../../../components/admin/products/list/ProductsList'

export default {
  components: {
    ProductsList,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'products',
      adminFields: [
        {
          key: 'id',
          label: this.$t('Id'),
        },
        {
          key: 'name',
          label: this.$t('Name'),
        },
        {
          key: 'value',
          label: this.$t('Value'),
        },
        {
          key: 'display_unit',
          label: this.$t('Unit'),
        },
        {
          key: 'price',
          label: this.$t('Price'),
        },
        {
          key: 'discount',
          label: this.$t('Discount'),
        },
        {
          key: 'display_type',
          label: this.$t('Type'),
        },
        {
          key: 'action',
          label: '',
        },
      ],
    }
  },
}
</script>

<style lang="scss">

</style>
